import rest from './rest'
import rotas from '../services/rotas'

const lista = () => {
  let central = []
  try{
    const retorno = rest.get(rotas.centralPrecos)
    retorno.then(ret => {
      //console.log(ret)
      if ((ret.success) && (ret.lista !== '')){
        central = ret.lista
        sessionStorage.setItem('id', central[0].filial_id)
        sessionStorage.setItem('filial', central[0].central)
      }
    })
    return (central)
  }catch(err){
    return ('')
  }
}

const central = () => {
  if (sessionStorage.getItem('id')) {
    let filial = {id: sessionStorage.getItem('id'), filial: sessionStorage.getItem('filial')}
    //console.log(filial)
    return filial
  }

  return {id:'', filial:'Selecione a central'}
}

const setCentral = (id, filial) => {
  sessionStorage.setItem('id', id)
  sessionStorage.setItem('filial', filial)
  return true
}

export default {
  central, setCentral, lista
}
